import interceptor from '@/plugins/interceptor';
const pathController = '/Activities'

export default {
  state: () => ({}),
  mutations: {},
  actions: {
    async activities_attaches(_, contentId) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/attaches/${contentId}`
      );
    },
    /* EN DESUSO
    async activities_uploadNewAttach(_,model) {
      return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_URL}${pathController}/attaches/`,model);
    }, 
    */
    async activities_finalPracticeStudentsQty(_, courseId) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Courses/${courseId}/courseStudentMetadata/FinalPracticeStudentsQty`
      );
    },
    async activities_finalPracticeStudentsQtyUpdate(_, model) {
      return await interceptor.authenticate.post(
        `${process.env.VUE_APP_API_LMS_URL}/Courses/${model.courseId}/courseStudentMetadata/FinalPracticeStudentsQty`,
        {value: model.qty}
      );
    },
    async activities_TotalStudentsQty(_, courseId) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Courses/${courseId}/courseStudentMetadata/TotalStudentsQty`
      );
    },
    async activities_TotalStudentsQtyUpdate(_, model) {
      return await interceptor.authenticate.post(
        `${process.env.VUE_APP_API_LMS_URL}/Courses/${model.courseId}/courseStudentMetadata/TotalStudentsQty`,
        {value: model.qty}
      );
    },
    async activities_updateAttaches(_, model) {
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/attaches/`,
        model
      );
    },

    /* Only for tutors */
    async activities_tutorResume(_, contentId) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Tutors/contents/${contentId}/resumes`
      );
    },
    async activities_tutorDetail(_, props) {
      const { contentId, status } = props;
      return await interceptor.authenticate.get(
        `${
          process.env.VUE_APP_API_LMS_URL
        }/Tutors/contents/${contentId}/submissions?status=${
          status === "All" ? "" : status
        }`
      );
    },
    async activities_forumUserHistory(_, params) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Tutors/forums/${params.contentId}/histories/${params.userId}`
      );
    },
    async activities_attachUserHistory(_, params) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Tutors/attaches/${params.contentId}/histories/${params.userId}`
      );
    },
    async forum_UserHistory(_, params) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Tutors/forums/${params.contentId}/histories/${params.userId}`
      );
    },
    async muro_UserHistory(_, params) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Tutors/forums/${params.contentId}/histories/${params.userId}`
      );
    },
    async activities_attachPostFeedback(_, model) {
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_URL}/Tutors/feedback`,
        model
      );
    },
    async activities_attachEditFeedback(_, model) {
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_URL}/Tutors/manyFeedback`,
        model
      );
    },
    async activities_attachManyFeedback(_, model) {
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_URL}/Tutors/feedback`,
        model
      );
    },
    async activities_submissionsFilters() {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Tutors/submissionsFilterOptions`
      );
    },
    async contentShare__checkEmail(_, body) {
      let { identifier, email } = body
      return await interceptor.anonymous.get(
        `${process.env.VUE_APP_API_LMS_URL}/Activities/contentShare/${identifier}/referredUser/${email}`
      );
    },
    async contentShare__sendUser(_, body) {
      let { identifier, req } = body
      return await interceptor.anonymous.post(
        `${process.env.VUE_APP_API_LMS_URL}/Activities/contentShare/${identifier}/referredUser`,
        req
      );
    },
    async contentShare__activity(_, identifier) {
      return await interceptor.anonymous.get(
        `${process.env.VUE_APP_API_LMS_URL}/Activities/contentShare/${identifier}/content`
      );
    },
  },
};